import React, { useCallback, useEffect, useState } from "react";

import { Box } from "@mui/material";
import debounce from "lodash.debounce";
import { connect } from "react-redux";

import JobLiveGridView from "../components/Job/JobLiveGridView";
import JobLiveHeader from "../components/Job/JobLiveHeader";
import JobLiveTableView from "../components/Job/JobLiveTableView";
import { setActionButtonToggle as setActionButtonToggleAction } from "../redux/slices/authSlice";
import { getAllPosts as getAllPostsAction } from "../redux/slices/postsSlice";

/* ============================================================================
  Posts
============================================================================= */
const Posts = ({
  companyId,
  isCompanySetup,
  postsData,
  totalPosts,
  getAllPosts,
  setActionButtonToggle,
}) => {
  console.log("companyId in post", companyId);
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("All");
  const [view, setView] = useState("list");
  const [page, setPage] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Console log for grid view data
  console.log("Data available for GridView");

  useEffect(() => {
    if (!isCompanySetup) {
      setActionButtonToggle(true);
      setIsLoading(false);
    } else {
      _getData({
        _page: page,
        take: rowsPerPage,
        _query: query,
        _filter: filter,
      });
    }
  }, [page]);

  useEffect(() => {
    if (postsData[page]) {
      setTableData(postsData[page]);
    }
  }, [postsData]);

  const _getData = useCallback(
    async ({ _page, take = rowsPerPage, _query, _filter, hideLoader }) => {
      // console.log("calling get data");
      if (!hideLoader) {
        setIsLoading(true);
      }

      await getAllPosts({
        take,
        page: _page,
        query: _query,
        filter: _filter,
        companyId,
      });

      if (!hideLoader) setIsLoading(false);
    },
    [page, query, query, filter, rowsPerPage]
  );

  const debounceFn = useCallback(
    debounce(async (value) => {
      setIsLoading(true);
      await _getData({
        _page: 1,
        _query: value,
        _filter: filter,
        take: rowsPerPage,
      });
      setIsLoading(false);
    }, 1000),
    [filter, rowsPerPage]
  );

  const _handleSearchTextChange = (value) => {
    setPage(1);
    setQuery(value);
    debounceFn(value);
  };
  const _handleFilterChange = async (value) => {
    setPage(1);
    setFilter(value);
    setIsLoading(true);
    await _getData({
      _page: 1,
      _query: query,
      _filter: value,
      take: rowsPerPage,
    });
    setIsLoading(false);
  };

  const _handleRowsPerPageChange = (event) => {
    setPage(1);
    setRowsPerPage(parseInt(event.target.value, 10));
    _getData({
      _page: 1,
      _query: query,
      _filter: filter,
      take: parseInt(event.target.value, 10),
    });
  };

  const _handleViewChange = (view) => {
    if (view === "list") setPage(1);
    console.log("View changed:", view);

    setView(view);
  };

  const _handleScrollEndReach = async () => {
    setPage(page + 1);
  };

  const onRefresh = () => {
    _getData({
      _page: page,
      _query: query,
      _filter: filter,
      take: rowsPerPage,
    });
  };

  return (
    <Box height="100%">
      <JobLiveHeader
        view={view}
        query={query}
        filter={filter}
        setView={setView}
        totalPosts={totalPosts}
        onFilterChange={_handleFilterChange}
        onSearch={_handleSearchTextChange}
        onViewChange={_handleViewChange}
        onReload={onRefresh}
      />

      {view === "list" ? (
        <JobLiveTableView
          page={page}
          setPage={setPage}
          isLoading={isLoading}
          tableData={tableData}
          rowsPerPage={rowsPerPage}
          totalPosts={totalPosts}
          onRowsPerPageChange={_handleRowsPerPageChange}
        />
      ) : (
        <JobLiveGridView
          isLoading={isLoading}
          onScrollEndReach={_handleScrollEndReach}
        />
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  // isCompanySetup: !!state.auth?.user?.company_id,
  isCompanySetup: !!(
    state.companies?.companies?.length > 0 && state.companies.companies[0]?.id
  ),
  postsData: state.posts?.postsData,
  totalPosts: state?.posts?.totalPosts,
});

const mapDispatchToProps = {
  getAllPosts: getAllPostsAction,
  setActionButtonToggle: setActionButtonToggleAction,
};

/* Export
============================================================================= */
export default connect(mapStateToProps, mapDispatchToProps)(Posts);
